import { render, staticRenderFns } from "./PriceComparisonReport.vue?vue&type=template&id=28c702e6&"
import script from "./PriceComparisonReport.vue?vue&type=script&lang=js&"
export * from "./PriceComparisonReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports